import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { loginUser } from "../../api/authApi";
import { useAuth } from "../../context/AuthContext";
import "./LoginPage.css";

function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  async function handleSubmit(event) {
    event.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const data = await loginUser({ email, password });
      login(data.user, data.token);
      navigate("/");
    } catch (err) {
      setError(err.message || "Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <main className="tt-login-wrap">
      <form className="tt-login-card" onSubmit={handleSubmit}>
        <h1 className="tt-login-title">Welcome back</h1>
        <p className="tt-login-subtitle">Log in to keep up with Today Talks</p>

        {error && <p className="tt-login-error" role="alert">{error}</p>}

        <label className="tt-login-label" htmlFor="login-email">Email</label>
        <input
          id="login-email"
          type="email"
          className="tt-login-input"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          autoComplete="email"
          required
        />

        <label className="tt-login-label" htmlFor="login-password">Password</label>
        <input
          id="login-password"
          type="password"
          className="tt-login-input"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="current-password"
          required
        />

        <button type="submit" className="tt-login-submit" disabled={loading}>
          {loading ? "Logging in..." : "Log In"}
        </button>

        <p className="tt-login-footer-text">
          Don't have an account? <Link to="/register" className="tt-login-link">Register</Link>
        </p>
      </form>
    </main>
  );
}

export default LoginPage;
